import { authAPIUrl } from "@/environment";
import { SolutionTrainService } from "@/services/solutionTrain.service";

import { catched } from "./catched";

export class SolutionTrainHandler {
  constructor() {
    this.solutionTrainService = new SolutionTrainService(authAPIUrl);
  }

  getSolutionTrains() {
    return catched(this.solutionTrainService.getSolutionTrains());
  }

  getSolutionTrain(id) {
    return catched(this.solutionTrainService.getSolutionTrain(id));
  }

  getMembers(id) {
    return catched(this.solutionTrainService.getMembers(id));
  }

  createSolutionTrain(name, arts, userIds) {
    return this.solutionTrainService.createSolutionTrain(name, arts, userIds); // not catched -> error is exposed via FeedbackButton
  }

  updateSolutionTrain(id, name, arts, userIds) {
    return this.solutionTrainService.updateSolutionTrain(id, name, arts, userIds); // not catched -> error is exposed via FeedbackButton
  }

  deleteSolutionTrain(id) {
    return catched(this.solutionTrainService.deleteSolutionTrain(id));
  }
}
